
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/basecamplejeune/privacy-policy",
      function () {
        return require("private-next-pages/basecamplejeune/privacy-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/basecamplejeune/privacy-policy"])
      });
    }
  